<template>
  <div class="ds-panel">
    <div class="ds-head ds-toggle" @click="$emit('update:open', !open)">
      <span class="chev">{{ open ? '&#9660;' : '&#9654;' }}</span>
      <b>{{ title }}</b>
      <span v-if="unavailable" class="muted">&mdash; {{ unavailableText }}</span>
      <span v-else class="ds-counts">
        <span class="ds-count" :class="{'has': count}">{{ count }}</span>
        <span v-if="excluded" class="ds-count ds-count-excluded" title="Excluded (not counted)">{{ excluded }}</span>
      </span>
    </div>
    <div v-if="open && !unavailable">
      <div v-if="(count + excluded) > 0" class="ds-body"><slot/></div>
      <div v-else class="ds-empty">{{ empty }}</div>
    </div>
  </div>
</template>

<script>
// a collapsible titled panel used by every Data Sync page: shows a count, an empty state, and an
// "unavailable" state (for a source that could not be read), with the diff content in the slot.
export default {
  name: 'data_sync_section',
  props: {
    title: {type: String, required: true},
    count: {type: Number, default: 0},          // active (non-excluded) count, shown in the badge
    excluded: {type: Number, default: 0},        // grayed second badge; items stay in the list
    open: {type: Boolean, default: true},
    empty: {type: String, default: 'No differences.'},
    unavailable: {type: Boolean, default: false},
    unavailableText: {type: String, default: 'Unavailable.'},
  },
}
</script>

<style scoped>
@import './data_sync.css';
</style>
